"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.autoAckEventMapper = autoAckEventMapper;
exports.autoAckRuleMapper = autoAckRuleMapper;
exports.autoAckRuleToRequest = autoAckRuleToRequest;
const models_1 = require("../models");
function autoAckEventMapper(groups) {
    return (groups !== null && groups !== void 0 ? groups : []).flatMap(group => {
        var _a;
        return ((_a = group.events) !== null && _a !== void 0 ? _a : []).map(event => ({
            key: event.key,
            displayName: event.displayName,
            category: group.category,
        }));
    });
}
const knownKeys = (groups, allowed) => groups.every(group => group.every(criteria => allowed.includes(criteria.key)));
function autoAckRuleMapper(rules) {
    return (rules !== null && rules !== void 0 ? rules : []).map((rule, index) => {
        var _a, _b, _c;
        const userCriteria = (_a = rule.userCriteria) !== null && _a !== void 0 ? _a : [];
        const patientCriteria = (_b = rule.patientCriteria) !== null && _b !== void 0 ? _b : [];
        return {
            id: `rule-${index}`,
            events: (_c = rule.events) !== null && _c !== void 0 ? _c : [],
            userCriteria,
            patientCriteria,
            isEditable: knownKeys(userCriteria, models_1.AUTO_ACK_USER_KEYS) &&
                knownKeys(patientCriteria, models_1.AUTO_ACK_PATIENT_KEYS),
            raw: rule,
        };
    });
}
function autoAckRuleToRequest(rule) {
    // A rule we cannot render goes back exactly as it was read — PUT replaces the
    // whole array, so rewriting it from a partial view would destroy it.
    if (!rule.isEditable)
        return rule.raw;
    return Object.assign({ events: rule.events, userCriteria: rule.userCriteria }, (rule.patientCriteria.length && {
        patientCriteria: rule.patientCriteria,
    }));
}
